import Link from 'next/link';

type Props = {
  children: React.ReactNode;
  href: string;
};

const ExternalLink = (props: Props) => {
  return (
    <Link href={props.href} passHref target="_blank" className="font-medium text-blue-500 no-underline hover:underline">
      {props.children}
    </Link>
  );
};

export default ExternalLink;
